import React from 'react';
import DataTable from 'components/data-table';
import RowItemKeHoachResult from './table-row/RowItemKeHoachResult.jsx';
import {header} from "constants/table";
import {Button, Dialog} from '@blueprintjs/core';
import {Input} from 'components/tt-forms/common';
import { ThanhTra } from 'api';

class SearchKeHoachTT extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state ={
      pageData: {
        number: 0,
        size: 10
      },
      isOpen: false,
      soQuyetDinh: this.props.searchKey,
      loading: false,
      dataList: []
    }
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }
  componentDidMount() {
    this.searchData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen) {
      this.setState({soQuyetDinh: nextProps.searchKey}, () => {
        this.searchData();
      });
    }
  }

  searchData() {
    this.setState({
      loading: true
    });
    let inputParams = {
      size: this.state.pageData.size,
      page: this.state.pageData.number,
      keHoachCurrentId: this.props.keHoachCurrentId
    }
    if (this.state.soQuyetDinh) {
      inputParams.soQuyetDinh = this.state.soQuyetDinh;
    }

    ThanhTra.actions.getKeHoachThanhTraOld.request('', inputParams).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({
          dataList: res.data._embedded.keHoachThanhTras,
          pageData: res.data.page
        });
      } else {
        this.setState({
          dataList: [],
          pageData: {
            number: 0,
            size: 10
          }
        });
      }
      this.setState({
        loading: false
      });
    });
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.searchData();
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.searchData();
  }

  render() {
    return (
      <Dialog className="panel-popup dialog-search-result" inline={ false } isOpen={this.props.isOpen} onClose={this.props.onClose} title="Danh sách kết quả tìm kiếm">
        <div className="pt-dialog-body">
          <div id="list-people-search" className="search-name-container">
            <form className="items-form" onSubmit={this.searchData.bind(this)} action="javascript:void(0)">
              <div className="rows">
                <Input label="Quyết định phê duyệt KHTT/KHKT" className="col-w22" value={this.state.soQuyetDinh} onChange={this.onChange.bind(this, 'soQuyetDinh')} maxLength={255}/>

                <div className="col-2">
                  <label className="seacrh-people">
                    <Button type="submit" className="btn-search" text="Tìm kiếm"/>
                  </label>
                </div>
              </div>
            </form>

            <DataTable
              header = {header.searchKHTTDialog}
              dataList = {this.state.dataList}
              hideButtonExport={true}
              pageData= {this.state.pageData}
              parent = {this}
              tableLoading = {this.state.loading}>
              <RowItemKeHoachResult onSelected={this.props.onSelected}/>
            </DataTable>

          </div>
        </div>
      </Dialog>
    );
  }
}

export default SearchKeHoachTT;



// WEBPACK FOOTER //
// ./src/components/modules/dialog/SearchKeHoachTT.jsx